// extracted by mini-css-extract-plugin
export default {"ShareButton":"ShareButton_ShareButton__R6PZU","SVG":"ShareButton_SVG__BmyM2"};